module.exports = __webpack_public_path__ + "img/magento-custom-development@2x.f5e928ca.jpg";